import React, { useState, useEffect } from "react";
// import ReactDOM from "react-dom";
// import Editor from "@monaco-editor/react";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-github";
function CodeEditor(props) {
  // const editorRef = useRef(null);

  const [currentValue, setCurrentValue] = useState(props.defaultHTML);

  // function handleEditorDidMount(editor, monaco) {
  //   editorRef.current = editor;
  //   // console.log(editorRef.current.getValue());
  // }

  useEffect(() => {
    setCurrentValue(props.defaultHtml);
  }, [props.defaultHtml]);

  function showValue() {
    props.submit(currentValue);
    // setCurrentValue(currentValue);
  }

  function onChange(newValue) {
    if (newValue) {
      setCurrentValue(newValue);
    }
  }

  return (
    <div>
      <button
        onClick={showValue}
        className="absolute m-5 z-50 right-0 bottom-0 bg-indigo-700 hover:bg-indigo-600 text-white font-medium text-sm py-2 px-3 rounded"
      >
        Build Template
      </button>
      <AceEditor
        mode="html"
        width="100%"
        style={{ paddingTop: "6px" }}
        height="95vh"
        // theme="github"
        onChange={onChange}
        name="UNIQUE_ID_OF_DIV"
        defaultValue={props.defaultHtml}
        // editorProps={{ $blockScrolling: true }}
      />
      {/* <Editor
        height="100vh"
        defaultLanguage="html"
        defaultValue={props.defaultHtml}
        onMount={handleEditorDidMount}
      /> */}
    </div>
  );
}

export default CodeEditor;
